import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import 'react-credit-cards/es/styles-compiled.css';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import ReactDOMServer from "react-dom/server";
import OpenModal from './OpenModal';
import color from '@material-ui/core/colors/amber';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',     
    transform             : 'translate(-50%, -50%)',
    padding               : '0',
    binvoice                : 'none',
    binvoiceRadius          : '0',
    boxShadow             : '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.6)',
    overlfow              : 'hidden'
  }
};

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    margin: theme.spacing.unit / 2,
    [theme.breakpoints.up('sm')]: {
      //paddingTop: 24,
    }
  },
  typo: {
    padding: theme.spacing.unit * 3
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonLink: {
    color: 'inherit',
    textDecoration: 'none'
  },
  header: {
    paddingLeft: '24px',
    paddingRight: '24px', 
    fontSize: '26px',
    fontFamily: 'Averia Serif Libre, cursive',
    fontWeight: '100',
    color: 'red',
     backgroundColor: '#fa451c'
  },
  InvoiceInfo:{
    
  },
  invoiceinfo_container_web:{
    /*display: 'flex',*/
    width: '100%',
    /*content: 'center',*/
    marginTop: '10px'
  },
  invoice_Information:{
    fontSize:'14px'
  },
  invoiceInformation_head_top:{
   color:'#000',
   width:'100%',
   height:'30px'
  },
  invoicecode:{
    float: 'left',
    color:'#000',
    marginBottom: '.5%',
    paddingLeft:'10px'
  },
  invoiceDate:{
    float: 'right',
    color:'#000',
    marginBottom: '.5%',
    textAlign:'right',
    paddingRight:'10px'
  },
  invoiceInformation_head:{
  backgroundColor:'#000',
  color: '#fff',
  textAlign: 'center',
  height: '26px',
  lineHeight: '25px'
},
label:{
  width:'185px',
  display:'inline-block',
  paddingLeft:'10px'
},
billing_shipment_details:{
width: '100%',
display:'inline-block'
},
billing_details:{
  padding: '0 1%',
  paddingLeft: '0',
  width:'50%',
  float:'left'
},
shipment_details:{
  width:'50%',
  float:'right',
  padding: '0',
  paddingLeft: '0'
},
billing_head:{
  backgroundColor:'#000',
  color: '#fff',
  textAlign: 'center',
  height: '26px',
  lineHeight: '25px'
},
shipment_head:{
  backgroundColor:'#000',
  color: '#fff',
  textAlign: 'center',
  height: '26px',
  lineHeight: '25px'
},
invoiceItem_Information:{
  width:'100%'
},
item_Head:{
  display:'flex',
  backgroundColor:'#000',
  color: '#fff',
  padding:'0',
  margin:'0',
},
item_Body:{
  display:'flex',
  padding:'0',
  margin:'0',
},
item_Head_line:{
    flex: '1 1',
    padding: '1%',
    textAlign: 'center'
},
item_Body_line:{
  flex: '1 1',
  padding: '1%',
  textAlign: 'center'
}
});

class InvoiceInfo extends Component {

  constructor(props) {
    super(props);   
    this.state = {
      modalIsOpen: false,
      invoiceDetails:[],
      invoiceItemDetails:[],
  }
   this.openModal = this.openModal.bind(this);      
   this.closeModal = this.closeModal.bind(this);
}

openModal = (modalMessage) =>{     
  this.setState(
      {
      modalIsOpen: true,
      modalMessage:modalMessage
  });        
}

componentWillMount() {
  let invoiceNo = this.props.location.pathname.split('/')[2];
  this.getInvoiceDetails(invoiceNo);
}

async getInvoiceDetails(invoiceNo){
try{
  const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_INVOICE_DETAIL_URL}?invoice-number=${invoiceNo}`,
  {
    method: 'GET',
    headers: {        
      Authorization: `${process.env.REACT_APP_API_TOKEN}`
    }})
  const data =  await response.json();
  if (data && data.length > 0) {
    this.setState({
      invoiceDetails: data[0],
      invoiceItemDetails: data[0].invoiceLineDetails
    })
  } else {
  }
  } catch(error) {
    
  }
 
}

downloadInvoicePDF(e,invoiceNo){
  e.preventDefault();
  try{
    const response = fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_INVOICE_DOWNLOAD_URL}?invoice-number=${invoiceNo}`,
    {
      method: 'GET',
      headers: {        
        Authorization: `${process.env.REACT_APP_API_TOKEN}`
      }}).then((res) => { return res.blob(); })
      .then((data) => {
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(data);
        a.filename = invoiceNo;
        a.target = "_blank";
        //a.download = invoiceNo;
        a.click();
      });
    } catch(error) {
      
    }
}

closeModal = () => {
  this.setState({modalIsOpen: false});
}

close_modal() {
  this.closeModal()
}

componentDidMount(){
}

render() {
    const { classes } = this.props;
    //console.log(classes);
    //const customer = JSON.parse(localStorage.getItem('customer'));
    //console.log(localStorage.getItem('customer'));
    //console.log(localStorage.getItem('token'));
    //console.log(localStorage.getItem('code'));
    let token = localStorage.getItem('token');
    let code =  localStorage.getItem('code');
    const invoiceInfo = this.state.invoiceDetails;
    const invoiceLineInfo = this.state.invoiceItemDetails;
    //console.log(invoiceLineInfo);
    return (
        <div id="invoice" className={classes.root}>
            <div className={classes.table}>
            <div className={classes.invoiceinfo_container_web}>
                    {this.state.invoiceDetails !== null && this.state.invoiceDetails !== '' && this.state.invoiceDetails !== [] ?
                    <div>
                            {/* <div className="invoiceapproval-title">invoice Approval List</div> */}
                            <div className={classes.invoice_Information}>
                                <div className={classes.invoiceInformation_head_top}><label className={classes.invoicecode}></label><span className={classes.invoiceDate} style={{fontSize: '16px', color: '#fa451c', cursor: 'pointer',textDecoration:'underline',position:'relative',top:'-18px'}} onClick={(e)=>this.downloadInvoicePDF(e,invoiceInfo.invoiceNumber)}>Download Invoice PDF</span></div>
                                <div className={classes.invoiceInformation_head_top}><label className={classes.invoicecode}>Invoice Number: {invoiceInfo.invoiceNumber}</label><label className={classes.invoiceDate}>Invoice Date: {invoiceInfo.orderDate}.</label></div>
                                <div className="clearfix"></div>
                                <div className={classes.invoiceInformation_head}>Invoice Information</div>
                                <div className={classes.invoiceInformation_details}>
                                    <p><label className={classes.label}>Customer Code</label><span>{invoiceInfo.billToCustomerNo}</span></p>
                                    <p><label className={classes.label}>Posting Date</label><span>{invoiceInfo.postingDate}</span></p>
                                    <p><label className={classes.label}>Posting Description</label><span>{invoiceInfo.postingDescription}</span></p>
                                    <p><label className={classes.label}>Payment Terms</label><span>{invoiceInfo.paymentTermsCode}</span></p>
                                    <p><label className={classes.label}>Sales Order Number</label><span>{invoiceInfo.orderNo}</span></p>
                                </div>
                                <div className={classes.billing_shipment_details}>
                                        <div className={classes.billing_details}>
                                            <p className={classes.billing_head}><span>Billing Address</span></p>
                                            <p><label className={classes.label}>Bill-to Name</label><span>{invoiceInfo.billToName}</span></p>
                                            <p><label className={classes.label}>Bill-to Address </label><span>{invoiceInfo.billToAddress}</span></p>
                                            <p><label className={classes.label}>Bill-to Address 2</label><span>{invoiceInfo.billToAddress2}</span></p>
                                            <p><label className={classes.label}>Bill-to City</label><span>{invoiceInfo.billToCity}</span></p>
                                            <p><label className={classes.label}>Bill-to State</label><span>{invoiceInfo.billToCountry}</span></p>
                                            <p><label className={classes.label}>Bill-to Country</label><span>{invoiceInfo.billToCtyRgnCode}</span></p>
                                            <p><label className={classes.label}>Bill-to Post Code</label><span>{invoiceInfo.billToPostCode}</span></p>
                                            <p><label className={classes.label}>Bill-to Phone No</label><span>{invoiceInfo.billToPhoneNo}</span></p>
                                        </div>
                                        <div className={classes.shipment_details}>
                                            <p className={classes.shipment_head}><span>Shipping Address</span></p>
                                            <p><label className={classes.label}>Ship-to Name</label><span>{invoiceInfo.shipToName}</span></p>
                                            <p><label className={classes.label}>Ship-to Address </label><span>{invoiceInfo.shipToAddress}</span></p>
                                            <p><label className={classes.label}>Ship-to Address 2</label><span>{invoiceInfo.shipToAddress2}</span></p>
                                            <p><label className={classes.label}>Ship-to City</label><span>{invoiceInfo.shipToCity}</span></p>
                                            <p><label className={classes.label}>Ship-to State</label><span>{invoiceInfo.sellToCountry}</span></p>
                                            <p><label className={classes.label}>Ship-to Country</label><span>{invoiceInfo.sellToCtyRgnCode}</span></p>
                                            <p><label className={classes.label}>Ship-to Post Code</label><span>{invoiceInfo.sellToPostCode}</span></p>
                                            <p><label className={classes.label}>Ship-to Phone No</label><span>{invoiceInfo.sellToPhoneNo}</span></p>
                                        </div>
                                </div>
                                <div className={classes.invoiceItem_Information}>
                                    <ul className={classes.item_Head} style={{listStyle:'none'}}>
                                        <li className={classes.item_Head_line}>Item Number</li>
                                        <li className={classes.item_Head_line}>Type</li>
                                        <li className={classes.item_Head_line}>Division Code</li>
                                        <li className={classes.item_Head_line}>Description</li>
                                        <li className={classes.item_Head_line}>Quantity</li>
                                        <li className={classes.item_Head_line}>Unit Price</li>
                                        {/*<li className={classes.item_Head_line}>Unit Cost LCY</li>*/}
                                        <li className={classes.item_Head_line}>Amount</li>
                                    </ul>                                    
                                    {invoiceLineInfo.map((item) =>
                                    (item.itemNumber !='' && item.amount > 0) &&
                                      <ul className={classes.item_Body} style={{listStyle:'none'}}>
                                       <li className={classes.item_Body_line}>{item.itemNumber}</li> 
                                       <li className={classes.item_Body_line}>{item.locationCode}</li> 
                                       <li className={classes.item_Body_line}>{item.shortcutDimensionCode1+' '+item.shortcutDimensionCode2}</li> 
                                       <li className={classes.item_Body_line}>{item.description+' '+item.description2}</li> 
                                       <li className={classes.item_Body_line}>{item.quantity > 0 ? parseInt(item.quantity) : parseInt(0)}</li> 
                                       <li className={classes.item_Body_line}><NumberFormat value={item.unitPrice} fixedDecimalScale={true} style={{ fontSize: 12, marginTop: '0%' }} decimalScale={2} displayType={'text'}></NumberFormat></li> 
                                       {/*<li className={classes.item_Body_line}><NumberFormat value={item.unitCostLCY!=="0E-20" ? item.unitCostLCY : parseInt(0)} fixedDecimalScale={true} style={{ fontSize: 12, marginTop: '0%' }} decimalScale={2} displayType={'text'}></NumberFormat></li>*/} 
                                       <li className={classes.item_Body_line}><NumberFormat value={item.amount} fixedDecimalScale={true} style={{ fontSize: 12, marginTop: '0%' }} decimalScale={2} displayType={'text'}></NumberFormat></li> 
                                       </ul>  
                                    )}
                                    
                                </div>
                        </div> </div>
                        : ''}
                    </div>
              
            </div>           
            {/*<Button component={Link} to={token && code ? `/authenticate/${token}/${code}` : '/'} variant="contained" color="primary" >
            Go Back
                                    </Button>*/}
        {/*<OpenModal 
                customStyles={customStyles} modalIsOpen={this.state.modalIsOpen}
                closeModal={this.closeModal} getParent={this.getParent}
                closeOnClick={this.close_modal.bind(this)} 
                modalMessage={this.state.modalMessage}>
        </OpenModal>*/}
        </div>
        
    );
  }
}

InvoiceInfo.propTypes = {
  classes: PropTypes.object.isRequired
};

export default (withStyles(styles)(InvoiceInfo));


// WEBPACK FOOTER //
// ./src/InvoiceInfo.js